import { Component, Input, OnInit } from '@angular/core';
import { Constants, PropertyTypeDescription } from '../../../../constants.new';

interface SearchResultParcelAcctNum {
    label: string;
    number: string;
}

@Component({
    selector: 'search-result-parcel',
    templateUrl: './searchResultParcel.component.html',
    standalone: false
})
export class SearchResultParcelComponent implements OnInit {
    constructor(private _constants: Constants) { }

    @Input() result: any;
    @Input() childEntity: any;

    propertyTypes: PropertyTypeDescription[];
    acctNums: SearchResultParcelAcctNum[];

    ngOnInit(): void {
        this.propertyTypes = Object.values(this._constants.PropertyTypes)
            .filter(x => !x.sequence)
            .sort((a, b) => a.id - b.id);

        this.acctNums = Object.keys(this.result)
            .filter(key => {
                const keyArr = key.split('.');
                return keyArr[0] === 'parcelAccountNumber' && this.result[key] && keyArr[1][0] !== '!';
            })
            .map(key => {
                return {
                    label: key.substring(key.indexOf('.') + 1),
                    number: this.result[key]
                }
            });
    }

    getPropType(id: number): string {
        if (!id) {
            return;
        }
        return this.propertyTypes.find(x => x.propertyTypeID === id)?.propTypeAbbr;
    }
}
